import { Component, Input } from '@angular/core';
import { CONSTANTS } from './loading-modal.constants';

@Component({
  selector: 'app-loading-modal',
  templateUrl: './loading-modal.component.html',
  styleUrls: ['./loading-modal.component.scss'],
  standalone: false,
})
export class LoadingModalComponent {
  @Input() loadingText = CONSTANTS.LOADING;
}
